var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1953 0.664062C16.705 0.664063 17.1939 0.866545 17.5543 1.22697C17.9147 1.58739 18.1172 2.07622 18.1172 2.58594V16.0391C18.1172 16.5488 17.9147 17.0376 17.5543 17.398C17.1939 17.7585 16.705 17.9609 16.1953 17.9609H2.74219C2.23247 17.9609 1.74364 17.7585 1.38322 17.398C1.0228 17.0376 0.820313 16.5488 0.820312 16.0391V2.58594C0.820312 2.07622 1.0228 1.58739 1.38322 1.22697C1.74364 0.866545 2.23247 0.664063 2.74219 0.664062H16.1953ZM15.7148 15.5586V10.4656C15.7148 9.63479 15.3848 8.83799 14.7973 8.2505C14.2098 7.66302 13.413 7.33297 12.5822 7.33297C11.7654 7.33297 10.8141 7.83266 10.3528 8.58219V7.51555H7.6718V15.5586H10.3528V10.8212C10.3528 10.0813 10.9486 9.47586 11.6885 9.47586C12.0453 9.47586 12.3875 9.6176 12.6398 9.86989C12.8921 10.1222 13.0338 10.4644 13.0338 10.8212V15.5586H15.7148ZM4.54875 6.00688C4.97691 6.00688 5.38753 5.83679 5.69029 5.53404C5.99304 5.23128 6.16313 4.82066 6.16313 4.3925C6.16313 3.49883 5.44242 2.76852 4.54875 2.76852C4.11804 2.76852 3.70498 2.93961 3.40042 3.24417C3.09586 3.54873 2.92477 3.96179 2.92477 4.3925C2.92477 5.28617 3.65508 6.00688 4.54875 6.00688ZM5.88445 15.5586V7.51555H3.22266V15.5586H5.88445Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedinIcon.832f043a38db8a190680a7c16a41d69c.svg";
export { ForwardRef as ReactComponent };